import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import IconPetProtector from 'components/icons/iconPetProtector';
import IconPlus from 'components/icons/iconPlus';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import Currency from 'components/consumer/Currency';
import CtaLink from 'components/essentials/Cta/CtaLink';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import { Redirect } from 'react-router-dom';
import ProtectionPlanModal from 'components/consumer/ProtectionPlanModal';
import useUserData from 'data-hooks/useUserData';
const ProtectionPlanButtonAndModal = t0 => {
  const $ = _c(70);
  const {
    close,
    eligible_plans,
    forPage,
    isAddPPLoading,
    isOpen,
    isRemovePPError,
    isRemovePPLoading,
    onSelect,
    openModal,
    productId,
    removeProtectionPlan,
    selectedProtectionPlan,
    showInactiveProtectionPlan,
    showSignInPageUponSelection,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "card" : t1;
  const [showSignInModal, setShowSignInModal] = useState(false);
  const {
    isLoggedIn
  } = useUserData();
  const buttonRef = useRef(null);
  const accessibleLabel = selectedProtectionPlan ? `Remove ${selectedProtectionPlan.plan_name}` : "Add 5-year Protection Plan";
  const isRowVariant = variant === "row";
  let t2;
  if ($[0] !== openModal || $[1] !== productId || $[2] !== removeProtectionPlan || $[3] !== selectedProtectionPlan || $[4] !== showSignInPageUponSelection) {
    t2 = () => {
      if (showSignInPageUponSelection) {
        setShowSignInModal(true);
        return;
      }
      if (selectedProtectionPlan && removeProtectionPlan) {
        removeProtectionPlan(true);
      } else {
        openModal(productId);
      }
    };
    $[0] = openModal;
    $[1] = productId;
    $[2] = removeProtectionPlan;
    $[3] = selectedProtectionPlan;
    $[4] = showSignInPageUponSelection;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onButtonClick = t2;
  let t3;
  if ($[6] !== isLoggedIn || $[7] !== showSignInModal || $[8] !== showSignInPageUponSelection) {
    t3 = !isLoggedIn && showSignInPageUponSelection && showSignInModal ? <LoginSidebar show={showSignInModal} onClose={() => setShowSignInModal(false)} /> : null;
    $[6] = isLoggedIn;
    $[7] = showSignInModal;
    $[8] = showSignInPageUponSelection;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isLoggedIn || $[11] !== showSignInPageUponSelection) {
    t4 = isLoggedIn && showSignInPageUponSelection && <Redirect to="/customer/orders" />;
    $[10] = isLoggedIn;
    $[11] = showSignInPageUponSelection;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const signIn = t5;
  if (isRowVariant) {
    let t6;
    if ($[16] !== close || $[17] !== eligible_plans || $[18] !== forPage || $[19] !== isOpen || $[20] !== onSelect || $[21] !== selectedProtectionPlan || $[22] !== showInactiveProtectionPlan) {
      t6 = <ProtectionPlanModal buttonRef={buttonRef} close={close} eligiblePlans={eligible_plans} forPage={forPage} isEdit={true} isOpen={isOpen} onSelect={onSelect} selectedPlan={selectedProtectionPlan} showInactiveProtectionPlan={showInactiveProtectionPlan} />;
      $[16] = close;
      $[17] = eligible_plans;
      $[18] = forPage;
      $[19] = isOpen;
      $[20] = onSelect;
      $[21] = selectedProtectionPlan;
      $[22] = showInactiveProtectionPlan;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    let t7;
    if ($[24] !== isRemovePPError) {
      t7 = isRemovePPError && <div className="text-sm font-bold text-red">{`${isRemovePPError}`}</div>;
      $[24] = isRemovePPError;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    let t8;
    if ($[26] !== isAddPPLoading || $[27] !== isRemovePPLoading || $[28] !== selectedProtectionPlan) {
      t8 = isAddPPLoading || isRemovePPLoading ? <ProgressLoaderDots /> : selectedProtectionPlan ? <><span className="min-w-0 flex-1 break-words">5-year {selectedProtectionPlan.plan_name}{" (+"}<Currency>{selectedProtectionPlan.plan_price}</Currency>)</span><span className="flex-shrink-0 text-sm font-bold text-brand hover:underline">Remove</span></> : <><span>Add Protection</span><IconPlus color="currentColor" width={18} height={18} /></>;
      $[26] = isAddPPLoading;
      $[27] = isRemovePPLoading;
      $[28] = selectedProtectionPlan;
      $[29] = t8;
    } else {
      t8 = $[29];
    }
    let t9;
    if ($[30] !== accessibleLabel || $[31] !== onButtonClick || $[32] !== t8) {
      t9 = <button data-xc="PDPAddProtectionPlanButton" className="flex w-full min-h-[3.75rem] cursor-pointer items-center justify-between gap-3 border border-solid border-gray-light6 bg-transparent px-4 py-3 text-left text-gray hover:border-gray-light2" type="button" aria-label={accessibleLabel} title={accessibleLabel} ref={buttonRef} onClick={onButtonClick}>{t8}</button>;
      $[30] = accessibleLabel;
      $[31] = onButtonClick;
      $[32] = t8;
      $[33] = t9;
    } else {
      t9 = $[33];
    }
    let t10;
    if ($[34] !== signIn || $[35] !== t6 || $[36] !== t7 || $[37] !== t9) {
      t10 = <>{t6}{signIn}{t7}{t9}</>;
      $[34] = signIn;
      $[35] = t6;
      $[36] = t7;
      $[37] = t9;
      $[38] = t10;
    } else {
      t10 = $[38];
    }
    return t10;
  }
  let t6;
  if ($[39] !== close || $[40] !== eligible_plans || $[41] !== forPage || $[42] !== isOpen || $[43] !== onSelect || $[44] !== selectedProtectionPlan || $[45] !== showInactiveProtectionPlan) {
    t6 = <ProtectionPlanModal buttonRef={buttonRef} close={close} eligiblePlans={eligible_plans} forPage={forPage} isEdit={true} isOpen={isOpen} onSelect={onSelect} selectedPlan={selectedProtectionPlan} showInactiveProtectionPlan={showInactiveProtectionPlan} />;
    $[39] = close;
    $[40] = eligible_plans;
    $[41] = forPage;
    $[42] = isOpen;
    $[43] = onSelect;
    $[44] = selectedProtectionPlan;
    $[45] = showInactiveProtectionPlan;
    $[46] = t6;
  } else {
    t6 = $[46];
  }
  let t7;
  if ($[47] !== isRemovePPError) {
    t7 = isRemovePPError && <div className="text-sm font-bold text-red">{`${isRemovePPError}`}</div>;
    $[47] = isRemovePPError;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  const t8 = !!selectedProtectionPlan;
  let t9;
  if ($[49] !== t8) {
    t9 = cx("flex relative items-center mt-0 min-h-[3rem] cursor-pointer border border-solid border-gray-light6 rounded p-3 bg-transparent text-left w-full", "hover:border hover:border-solid hover:border-gray-light2 hover:cursor-pointer", {
      active: t8
    });
    $[49] = t8;
    $[50] = t9;
  } else {
    t9 = $[50];
  }
  let t10;
  if ($[51] !== eligible_plans?.[0]?.plan_price || $[52] !== forPage || $[53] !== isAddPPLoading || $[54] !== isRemovePPLoading || $[55] !== removeProtectionPlan || $[56] !== selectedProtectionPlan) {
    t10 = isAddPPLoading || isRemovePPLoading ? <ProgressLoaderDots /> : <>{selectedProtectionPlan ? <div className="w-12 h-12 mr-1">{selectedProtectionPlan.plan_name.includes("Pet Protector Plan") ? <IconPetProtector /> : <IconProtectionPlan />}</div> : <div />}<div className="cursor-pointer w-full flex items-center min-w-0">{selectedProtectionPlan ? <span className={`block ml-2 text-sm font-bold text-gray flex justify-between items-center gap-2 w-full min-w-0 ${forPage}`}><span className="flex-1 min-w-0 break-words">5-year {selectedProtectionPlan.plan_name}{" (+"}<Currency>{selectedProtectionPlan.plan_price}</Currency>{") "}</span>{removeProtectionPlan ? <span className="flex-shrink-0 text-xs font-bold text-brand hover:underline">Remove</span> : <span className="text-xs font-bold text-brand hover:underline"><CtaLink to="/furniture-protection-plan/" size="xs" target="_blank" color="brand" hasArrow={false}>See Details</CtaLink></span>}</span> : <><span className="w-12 h-12 mr-1"><IconProtectionPlan circleFill="none" fill="#e0e0e0" />{" "}</span><span className="block ml-2 text-sm font-bold text-gray w-full"><span className="flex whitespace-pre flex-col"><span className="whitespace-normal">{"Add 5-year Protection Plan from"}{" "}<Currency>{eligible_plans?.[0]?.plan_price}</Currency></span><span className="text-xs font-bold text-brand">What's covered?</span></span><span className="text-xs font-bold text-brand hover:underline" /></span></>}</div></>;
    $[51] = eligible_plans?.[0]?.plan_price;
    $[52] = forPage;
    $[53] = isAddPPLoading;
    $[54] = isRemovePPLoading;
    $[55] = removeProtectionPlan;
    $[56] = selectedProtectionPlan;
    $[57] = t10;
  } else {
    t10 = $[57];
  }
  let t11;
  if ($[58] !== accessibleLabel || $[59] !== onButtonClick || $[60] !== t10 || $[61] !== t9) {
    t11 = <button data-xc="PDPAddProtectionPlanButton" className={t9} type="button" aria-label={accessibleLabel} title={accessibleLabel} ref={buttonRef} onClick={onButtonClick}>{t10}</button>;
    $[58] = accessibleLabel;
    $[59] = onButtonClick;
    $[60] = t10;
    $[61] = t9;
    $[62] = t11;
  } else {
    t11 = $[62];
  }
  let t12;
  if ($[63] !== t11 || $[64] !== t7) {
    t12 = <div className="mt-5">{" "}{t7}{t11}</div>;
    $[63] = t11;
    $[64] = t7;
    $[65] = t12;
  } else {
    t12 = $[65];
  }
  let t13;
  if ($[66] !== signIn || $[67] !== t12 || $[68] !== t6) {
    t13 = <>{t6}{signIn}{t12}</>;
    $[66] = signIn;
    $[67] = t12;
    $[68] = t6;
    $[69] = t13;
  } else {
    t13 = $[69];
  }
  return t13;
};
ProtectionPlanButtonAndModal.propTypes = {
  close: PropTypes.func,
  eligible_plans: PropTypes.arrayOf(PropTypes.shape({
    plan_name: PropTypes.string,
    plan_price: PropTypes.number
  })),
  forPage: PropTypes.oneOf(['cart', 'checkout', 'PDP', 'UserDashboardOrdersPage', 'UserDashboardPP']),
  isAddPPLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  isRemovePPError: PropTypes.string,
  isRemovePPLoading: PropTypes.bool,
  onSelect: PropTypes.func,
  openModal: PropTypes.func,
  productId: PropTypes.string,
  removeProtectionPlan: PropTypes.func,
  selectedProtectionPlan: PropTypes.shape({
    plan_name: PropTypes.string,
    plan_price: PropTypes.number
  }),
  showInactiveProtectionPlan: PropTypes.bool,
  showSignInPageUponSelection: PropTypes.bool,
  variant: PropTypes.oneOf(['card', 'row'])
};
export default ProtectionPlanButtonAndModal;